import ApiService from '@/core/services/api.service';

export function fetchStockSlipHistories(stockSlipId) {
  return ApiService.get(
    `v1/stock-slip-histories/by-stock-slip/${stockSlipId}`,
  ).then((response) => response.data?.data || []);
}
